module.exports = __webpack_public_path__ + "static/media/facebook.11a4028f.svg";